// Detecta si una respuesta del backend es una acción de verificación 3DS de Conekta.
//
// Solo se validan los campos que el flujo realmente necesita: si hay que presentar
// el reto (`requiresAction`), a dónde apuntar el iframe (`redirectUrl`) y qué orden
// confirmar después (`orderId`). Cualquier otro campo se ignora.
//
// Antes esto era un esquema de zod `.strict()` que además exigía `activePasses` y
// `newPasses`. Dos problemas: la respuesta de `buyCoins/confirm` no manda esos dos
// campos cuando Conekta pide otra verificación, así que el reto encadenado nunca se
// detectaba; y al ser estricto, cualquier campo nuevo en la respuesta apagaba la
// detección de 3DS por completo y en silencio.
//
// Se hace a mano en lugar de con zod porque `zod` es la única dependencia de
// web-clients que no queda instalada, y era justo este archivo —el que decide si se
// muestra el reto— el que no compilaba por no poder resolverla.

const isNonEmptyString = value => typeof value === 'string' && value.length > 0;

export const isConektaPaymentAction = value => {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  return (
    typeof value.requiresAction === 'boolean' &&
    isNonEmptyString(value.orderId) &&
    isNonEmptyString(value.redirectUrl) &&
    isNonEmptyString(value.paymentStatus)
  );
};
